module.exports = __webpack_public_path__ + "static/media/pic19.aefa5689.jpg";